import React from "react";
import ProjectAreaLayer from "./ProjectAreaLayer";
import WindTurbinesLayer from "./WindTurbinesLayer";
import LandParcelLayer from "./LandParcelLayer";

import { LayerManagerProps } from "../types";

/**
 * Koordiniert alle Layer in der richtigen Z-Index-Reihenfolge
 *
 * Layer-Reihenfolge (von unten nach oben):
 * 1. Projekt-Fläche
 * 2. Flurstücke
 * 3. Windenergieanlagen (höchster Z-Index)
 */
const LayerManager: React.FC<LayerManagerProps> = ({
  parcels,
  layerVisibility,
  projectName,
  flaecheCoordinates,
  anlagen,
  onParcelUpdate,
  onParcelClick,
  selectedParcelId,
  selectedAnlageId,
  onAnlagePositionChange,
  onAnlageSelect,
}) => {
  return (
    <>
      <ProjectAreaLayer
        projectName={projectName || ""}
        flaecheCoordinates={flaecheCoordinates || []}
      />

      {parcels && parcels.length > 0 && (
        <LandParcelLayer
          parcels={parcels}
          layerVisibility={layerVisibility}
          onParcelUpdate={onParcelUpdate}
          onParcelClick={onParcelClick}
          selectedParcelId={selectedParcelId}
        />
      )}

      <WindTurbinesLayer
        anlagen={anlagen || []}
        visible={layerVisibility.windenergieanlagen}
        flaecheCoordinates={flaecheCoordinates}
        onPositionChange={onAnlagePositionChange}
        onSelect={onAnlageSelect}
        selectedId={selectedAnlageId}
      />
    </>
  );
};

export default LayerManager;
